import { useTheme } from 'styled-components'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'
import { DeliveryMethod as DeliveryMethodInfo } from '@reveni-io/reveni-ui'

import UnifiedDeliveryMethodInfo from './UnifiedDeliveryMethodInfo/UnifiedDeliveryMethodInfo'
import * as Styles from './styles'

const DeliveryMethod = ({ deliveryMethod, regions, isUnifiedDashboard }) => {
  const theme = useTheme()

  return (
    <Styles.MainContainer>
      <Styles.PositionContainer>
        <Text type="bodyMRegular" color={theme.colors.text.subtle} customStyles={{ minWidth: '20px' }}>
          {deliveryMethod?.index}
        </Text>
      </Styles.PositionContainer>
      <Styles.Container>
        <Styles.DeliveryMethodInfoContainer>
          {isUnifiedDashboard ? (
            <UnifiedDeliveryMethodInfo deliveryMethod={deliveryMethod} />
          ) : (
            <DeliveryMethodInfo
              data={{
                ...deliveryMethod,
                carrier: deliveryMethod?.carriers?.[0],
                carrier_service: deliveryMethod?.carrier_services?.[0],
              }}
              regions={regions}
              isEditable={false}
              showSwitch={false}
              showDeliveryMethodLabel={false}
              showRegions={false}
              showRanges={false}
            />
          )}
        </Styles.DeliveryMethodInfoContainer>
        <Styles.SideContainer>
          <Styles.Total type="bodyMRegular">
            <FormatNumber style="decimal">{deliveryMethod?.count || 0}</FormatNumber>
          </Styles.Total>
          <Styles.Total type="bodyMRegular">
            <FormatNumber style="percent">{deliveryMethod?.percentage}</FormatNumber>
          </Styles.Total>
        </Styles.SideContainer>
      </Styles.Container>
    </Styles.MainContainer>
  )
}

export default DeliveryMethod
